import { Extension } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion, { type SuggestionProps } from '@tiptap/suggestion';
import type { SlashMenuItem } from '../../RichTextDescription/types';

export const CommentMentionSuggestionPluginKey = new PluginKey('commentMention');

export type CommentMentionSuggestionOptions = {
  items: (props: { query: string; editor: import('@tiptap/core').Editor }) => SlashMenuItem[];
  render: () => {
    onStart: (props: SuggestionProps<SlashMenuItem, SlashMenuItem>) => void;
    onUpdate: (props: SuggestionProps<SlashMenuItem, SlashMenuItem>) => void;
    onKeyDown: (props: { event: KeyboardEvent }) => boolean;
    onExit: () => void;
  };
  hasMentionableUsers: () => boolean;
};

export const CommentMentionSuggestion = Extension.create<CommentMentionSuggestionOptions>({
  name: 'commentMention',

  addOptions() {
    return {
      items: () => [],
      render: () => ({
        onStart: () => {},
        onUpdate: () => {},
        onKeyDown: () => false,
        onExit: () => {}
      }),
      hasMentionableUsers: () => false
    };
  },

  addProseMirrorPlugins() {
    const extension = this;

    return [
      Suggestion({
        editor: extension.editor,
        char: '@',
        pluginKey: CommentMentionSuggestionPluginKey,
        allowSpaces: false,
        startOfLine: false,
        allowedPrefixes: [' ', '\n'],
        command: ({ editor, range, props }) => {
          (props as SlashMenuItem).onSelect({ editor, range });
        },
        items: ({ query, editor }) => extension.options.items({ query, editor }),
        render: extension.options.render,
        allow: () => extension.options.hasMentionableUsers()
      })
    ];
  }
});
